import { useEffect, useState } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box, Checkbox, ConfirmPopup, Pressable } from '~/commonComponents';

const options = [
  'Working interviews are not necessary for my office',
  'Not needed for this position',
  'Already have a candidate in mind',
  'Other',
];

interface ISurveyPopupProps {
  onSkipPress: () => void;
  onSubmitPress: (reasons: string[]) => void;
}

export const SurveyPopup = ({ onSkipPress, onSubmitPress }: ISurveyPopupProps) => {
  const [reasons, setReasons] = useState<string[]>([]);
  const [otherReason, setOtherReason] = useState('');

  const isOtherSelected = reasons.includes('Other');

  useEffect(() => {
    if (!isOtherSelected) {
      setOtherReason('');
    }
  }, [isOtherSelected]);

  return (
    // @ts-expect-error -- missing props
    <ConfirmPopup
      dataCy="pp-survey-popup"
      leftButtonDataCy="skip-button"
      leftButtonText="Skip"
      leftButtonAction={() => onSkipPress()}
      rightButtonDataCy="submit-button"
      rightButtonText="Submit"
      rightButtonAction={() => {
        const formattedReasons = [...reasons];

        if (otherReason) {
          // add Other to reasons with prefix
          formattedReasons.push(`Other - ${otherReason}`);
        }

        onSubmitPress(formattedReasons);
      }}
    >
      <Box marginBottom={38} paddingHorizontal={20}>
        <Typography as="span" bold size="body_large" textAlign="center">
          Help Us Understand
        </Typography>
        <Typography as="span" color={colors.neutral[500]} textAlign="center" style={{ marginTop: 20, marginBottom: 28 }}>
          GoTu can help facilitate working interviews for your office. Can you tell us why your
          office doesn’t need this?
        </Typography>
        <Box paddingLeft={15} gap={18} alignItems="flex-start">
          {options.map((name) => (
            <Pressable
              key={name}
              onPress={() => {
                setReasons((prev) => {
                  if (prev.includes(name)) {
                    return prev.filter((itm) => itm !== name);
                  }

                  return [...prev, name];
                });
              }}
            >
              <Checkbox checked={reasons.includes(name)} />
              <Typography as="span" style={{ marginLeft: 12 }}>{name}</Typography>
            </Pressable>
          ))}
        </Box>
        {isOtherSelected && (
          <textarea
            style={{
              alignSelf: 'center',
              height: 80,
              width: '85%',
              fontSize: 16,
              marginTop: 20,
              color: colors.neutral[600],
              border: '1px solid transparent',
              borderRadius: '10px',
              backgroundColor: colors.neutral[50],
              boxShadow: 'inset 0px 2px 4px rgba(0, 0, 0, 0.25)',
            }}
            placeholder="Provide details here..."
            value={otherReason}
            onChange={(e) => setOtherReason(e.target.value)}
          />
        )}
      </Box>
    </ConfirmPopup>
  );
};
